export default "__VITE_ASSET__CCNWEWpz__"